import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  width: "100%",
  maxWidth: "1220px",
  margin: "0 auto",
  minHeight: "60vh",
  padding: "40px 20px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
}));

export const ContentCard = styled("div")(({ theme }) => ({
  width: "100%",
  maxWidth: "500px",
  padding: "40px 30px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 24,
  borderRadius: 12,
  boxShadow: `0 0 10px 0 ${theme.palette.shadowSm}`,
  backgroundColor: theme.palette.white,
  textAlign: "center",

  [theme.down("xs")]: {
    width: "100%",
    padding: "30px 20px",
    borderRadius: 8,
  },
}));

export const IconWrapper = styled("div")(({ theme }) => ({
  width: 80,
  height: 80,
  borderRadius: "50%",
  backgroundColor: theme.palette.primarySubtle,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: 8,

  "& svg": {
    width: 40,
    height: 40,
    color: theme.palette.primaryLight,
  },
}));

export const Title = styled("h1")(({ theme }) => ({
  fontSize: 28,
  fontWeight: 700,
  color: theme.palette.textPrimary,
  margin: 0,

  [theme.down("xs")]: {
    fontSize: 22,
  },
}));

export const Description = styled("p")(({ theme }) => ({
  fontSize: 16,
  fontWeight: 400,
  lineHeight: 1.6,
  color: theme.palette.textSecondary,
  margin: 0,

  [theme.down("xs")]: {
    fontSize: 14,
  },
}));

export const HomeButton = styled("button")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,
  padding: "14px 32px",
  fontSize: 16,
  fontWeight: 600,
  border: "none",
  borderRadius: 8,
  backgroundColor: theme.palette.searchButtonBg,
  color: theme.palette.white,
  cursor: "pointer",
  transition: "all 0.3s ease",

  "&:hover": {
    filter: "brightness(90%)",
    transform: "translateY(-2px)",
  },

  [theme.down("xs")]: {
    fontSize: 14,
    padding: "12px 24px",
  },
}));
